import { EXPECTED_PERMANENT_EVENTS } from "./constants";

/**
 * Tracks the ids of the permanent Transport callbacks.
 *
 * Invariants (docs/implementation-plan.md 3.9):
 *   INV-1 the tracked ids always match what is registered on the Transport.
 *         Guaranteed structurally by never calling Transport.cancel().
 *   INV-2 registration happens exactly once, inside init().
 *         resume/reset/panic/arm never change the registry.
 *   INV-3 clear() is called only from dispose(); afterwards size === 0.
 *   INV-4 size === 3 while alive, 0 when idle or disposed.
 */
export class EventRegistry {
  private ids: number[] = [];

  register(id: number): void {
    this.ids.push(id);
  }

  get size(): number {
    return this.ids.length;
  }

  assertEmpty(): void {
    if (this.ids.length !== 0) {
      throw new Error(
        `EventRegistry expected to be empty before registering permanent events, found ${this.ids.length}`,
      );
    }
  }

  assertFull(): void {
    if (this.ids.length !== EXPECTED_PERMANENT_EVENTS) {
      throw new Error(
        `EventRegistry expected ${EXPECTED_PERMANENT_EVENTS} permanent events, found ${this.ids.length}`,
      );
    }
  }

  /** Only dispose() may call this. Clears by id — never Transport.cancel(). */
  clearAll(clear: (id: number) => void): void {
    for (const id of this.ids) {
      clear(id);
    }
    this.ids = [];
  }
}
